import axios from "@/repositories/client";
import default_rate from "@/defaults/default-rate";

axios.getRates = (id, pagination, args = {}) => {

  args.dropdown = args.dropdown || false;

  let options = {
    params: {
      skip: pagination.size * (pagination.page - 1),
      take: pagination.size
    }
  };

  return axios.get(`athena/v1/hotels/${id}/rate-plans`, options)
    .then(response => {
      if(args.dropdown)
        return _.keyBy(response.data.data.map(rate => ({text: rate.name, value: rate.id})), 'value');

      return response.data;
    });
};

axios.getRate = (id, rate) => {

  if (rate === 'create')
    return new Promise((resolve => {
      resolve(_.cloneDeep(default_rate));
    }));

  return axios.get(`athena/v1/hotels/${id}/rate-plans/${rate}`)
    .then(response => {
      return response.data.data;
    });
};

axios.saveRate = (id, rate) => {
  let url = `athena/v1/hotels/${id}/rate-plans` + (rate.id ? `/${rate.id}` : '');
  let verb = rate.id ? 'PUT' : 'POST';

  return axios.request({method: verb, url: url, data: rate})
    .then(response => {
      return response.data.data;
    });
};

axios.destroyRate = (hotel, rate) => {
  return axios.delete(`athena/v1/hotels/${hotel}/rate-plans/${rate}`)
    .then(response => {
      return response.data;
    });
};

axios.getCosts = (id, pagination) => {

  let options = {
    params: {
      skip: pagination.size * (pagination.page - 1),
      take: pagination.size
    }
  };

  return axios.get(`athena/v1/hotels/${id}/rate-plans`, options)
    .then(response => {
      response.data.data = response.data.data.filter(rate => {
        return (rate.type === 'cost');
      });
      return response.data.data;
    });
};

axios.getSales = (id, pagination) => {

  let options = {
    params: {
      skip: pagination.size * (pagination.page - 1),
      take: pagination.size
    }
  };

  return axios.get(`athena/v1/hotels/${id}/rate-plans`, options)
    .then(response => {
      response.data.data = response.data.data.filter(rate => {
        return (rate.type === 'sale');
      });
      return response.data.data;
    });
};

export default axios;